import React, { createContext, useContext } from "react";

/**
 * Carries the form's attestation text (from the tax `metadata.attestation.text`)
 * down to the `SignatureBlock` field, which renders it above the consent control.
 * The forms response keeps the attestation copy in `response.metadata`, not on the
 * field itself, so the renderer threads it through here.
 */
const DynamicFormAttestationContext = createContext<string | undefined>(
  undefined
);

type ProviderProps = {
  attestationText?: string;
  children: React.ReactNode;
};

export const DynamicFormAttestationProvider: React.FC<ProviderProps> = ({
  attestationText,
  children
}) => (
  <DynamicFormAttestationContext.Provider value={attestationText}>
    {children}
  </DynamicFormAttestationContext.Provider>
);

export const useDynamicFormAttestationText = (): string | undefined =>
  useContext(DynamicFormAttestationContext);
